import React from 'react';
import styled from 'styled-components';

const StyledContentContainer = styled.div `
    padding: 20px;
    box-shadow: 1px 1px 5px 1px rgb(34 60 80 / 10%);
    border-radius: 8px;
    position: relative;
    // height: ${props => props.height || '100%'};
    background-color: ${props =>
        props.theme.color.palette.background.paper.defaultLight};

    ${props => ({...props.style})}

    // &:after {
    //     position: absolute;
    //     content: '';
    //     bottom: 0;
    //     left: 0;
    //     height: 100%;
    //     width: 100%;
    //     background: linear-gradient( 
    //         0deg,
    //         rgb(255 255 255 / 50%), 
    //         rgb(251 251 251 / 0%) 25% 
    //     );
    //     pointer-events: none;
    //     border-radius: 8px;
    // }
    
`

const ContentContainer = ({children, ...props}) => (
    <StyledContentContainer {...props}>
        {children}
    </StyledContentContainer>
)

export default ContentContainer;